import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"height":"600px"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_LinkOutlined = _resolveComponent("LinkOutlined")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, { spinning: _ctx.isLoading }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.activeKey,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeKey) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "1",
              tab: _ctx.tabstitle.invalid_con
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  dataSource: _ctx.cneeData,
                  columns: _ctx.cneeColumn,
                  pagination: _ctx.cneePage,
                  onChange: _ctx.tableCneeHandle,
                  size: "small"
                }, {
                  bodyCell: _withCtx(({column, record}) => [
                    (column.key === 'houseBillNumber')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (record.houseBillNumber === null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "-"))
                            : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(record.houseBillNumber), 1))
                        ], 64))
                      : (column.key === 'cneeName')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(record.lastName) + " " + _toDisplayString(record.firstName), 1))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["dataSource", "columns", "pagination", "onChange"])
              ]),
              _: 1
            }, 8, ["tab"]),
            _createVNode(_component_a_tab_pane, {
              key: "2",
              tab: _ctx.tabstitle.invalid_addr
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  dataSource: _ctx.addressData,
                  columns: _ctx.addressColumn,
                  pagination: _ctx.addressPage,
                  onChange: _ctx.tableAddrHandle,
                  size: "small"
                }, {
                  bodyCell: _withCtx(({column, record}) => [
                    (column.key === 'houseBillNumber')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (record.houseBillNumber === null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "-"))
                            : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(record.houseBillNumber), 1))
                        ], 64))
                      : (column.key === 'addr')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(record.address) + ", " + _toDisplayString(record.city) + "," + _toDisplayString(record.state), 1))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["dataSource", "columns", "pagination", "onChange"])
              ]),
              _: 1
            }, 8, ["tab"]),
            _createVNode(_component_a_tab_pane, {
              key: "3",
              tab: _ctx.tabstitle.overweight
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  dataSource: _ctx.overweightData,
                  columns: _ctx.overweightColumn,
                  pagination: _ctx.overweightPage,
                  onChange: _ctx.tableOverweightHandle,
                  size: "small"
                }, {
                  bodyCell: _withCtx(({column, record}) => [
                    (column.key === 'houseBillNumber')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (record.houseBillNumber === null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, "-"))
                            : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(record.houseBillNumber), 1))
                        ], 64))
                      : (column.key === 'shipDesc')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createTextVNode(_toDisplayString(record.nameEn) + " ", 1),
                            _createElementVNode("a", {
                              href: record.extraInformation.productUrl,
                              target: "_blank"
                            }, [
                              _createVNode(_component_LinkOutlined)
                            ], 8, _hoisted_11)
                          ]))
                        : (column.key === 'weight')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(record.weight) + _toDisplayString(record.weightUom), 1))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["dataSource", "columns", "pagination", "onChange"])
              ]),
              _: 1
            }, 8, ["tab"])
          ]),
          _: 1
        }, 8, ["activeKey"])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}